// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div#example1_filter {
    float: right;
}

.paging_simple_numbers{
    float: right;
}
.dataTables_empty{
  text-align: center;
}
span.link {
    padding: 5px;
    border: 1px solid gray;
    margin: 2px;
    border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/Css/pagesstyle.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;IACI,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,mBAAmB;AACvB","sourcesContent":["div#example1_filter {\n    float: right;\n}\n\n.paging_simple_numbers{\n    float: right;\n}\n.dataTables_empty{\n  text-align: center;\n}\nspan.link {\n    padding: 5px;\n    border: 1px solid gray;\n    margin: 2px;\n    border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
